import React from 'react'
import { Outlet } from 'react-router-dom'
import Logo from './logo/Logo'
import LanguageHead from './header/dropdown/language/Language'
import User from './header/dropdown/user/User'
import classNames from 'classnames'
import { ToastContainer } from 'react-toastify'

import { useTranslation } from 'react-i18next'

const AdminLayout = ({ tokenChecked }) => {
  const { t } = useTranslation()

  if (!tokenChecked) {
    return <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{t('admin.loading')}</span>
      </div>
    </div>
  }

  const headerClass = classNames({
    'nk-header is-regular': true,
    'is-light': true
  })

  return (
    <div className="nk-app-root">
      <div className="nk-main">
        <div className="nk-wrap">
          <div className={headerClass}>
            <div className="container-fluid">
              <div className="nk-header-wrap">
                <div className="nk-header-brand">
                  <Logo/>
                </div>
                <div className="nk-header-tools">
                  <ul className="nk-quick-nav">
                    <li className="language-dropdown d-none d-sm-block me-n1">
                      <LanguageHead/>
                    </li>
                    <li className="user-dropdown">
                      <User/>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="nk-content">
            <div className="container-fluid">
              <div className="nk-content-inner">
                <div className="nk-content-body">
                  <Outlet/>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default AdminLayout
